<template>
    <div>
        <filters :scope="filtersScope">
        </filters>
        <ConversionsTabs></ConversionsTabs>
        <div class="animated fadeIn courier">
          <div class="card-block">
              <div class="row">
                  <div class="col-md-12" v-show="loading">
                      <div class="logout-message" style="text-align: center;">{{ $t('message.loading') }}
                          <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                      </div>
                  </div>
              </div>
          </div>
          <div class="exelAll" style="overflow:hidden; width:100%">
              <div id="swipe1" v-hammer:pan="onSwipe" style="display:flex;flex-wrap: nowrap;" :style="{ 'transform': 'translate3d(' + x + 'px, 0px, 0px)'}" v-for="(indexMonth,indexYear) in totalAllColumns" :key="indexYear">
                  <div style="flex: 0 0 750px;" v-for="(rowsMonth,indexCourier,index) in indexMonth" :key="`${indexYear}_${indexCourier}`">
                      <div class=" statistic-table" style="margin-bottom:0; " >
                          <div class="card-header">
                              {{month[indexCourier - 1]}} {{indexYear}} г.<br/>
                          </div>
                          <StatisticTable :headColumns="headColumns"
                                          :footColumns="totalAllColumns[indexYear][indexCourier][0]"
                                          :totalColumnsDd="totalCourier[indexYear][indexCourier]"
                                          :rows="[]"
                                          :isExelAll="true"
                                          :isFlypostModal="true"
                                          @exportingAll="exportingAll"
                                          :classes="`${[indexYear]}-${[indexMonth]}`"
                                          :className="`${[indexYear]}-${[indexMonth]}`"
                                          :title="`${$t('statistic.in_total')}`">
                          </StatisticTable>
                      </div>
                  </div>
              </div>
              <div id="swipe" v-hammer:pan="onSwipe" :style="{ 'transform': 'translate3d(' + x + 'px, 0px, 0px)'}" v-for="(rowsCourier,indexYear) in rows" :key="indexYear">
                  <div style="display:flex;flex-wrap: nowrap;" v-for="(rowsMonth,indexCourier,index) in rowsCourier" :key="`${indexYear}_${indexCourier}`">
                      <div style="flex: 0 0 750px;" v-for="(rowsData, indexMonth) in rowsMonth"  :key="`${indexYear}_${indexCourier}_${indexMonth}`">
                          <div v-if="rowsData.length !== 0">
                              <div class=" statistic-table" style="margin-bottom:0; " >
                                  <StatisticTable :headColumns="headColumns"
                                                  :className="`${[indexYear]}-${[indexMonth]}`"
                                                  :footColumns="footColumns[indexYear][indexCourier][indexMonth][0]"
                                                  :rows="rowsData"
                                                  :isFlypostModal="true"
                                                  :title="`${Helper.getOfferTitle(Storage.offers, indexCourier)}`">
                                  </StatisticTable>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
    </div>
</template>

<script>
    import Filters from '../../../components/Filters.vue'
    import API from '../../../api/API'
    import FileSaver from 'file-saver'
    import Storage from '../../../api/Storage'
    import {map, isNaN, find, max} from 'lodash'
    import Helper from '../../../api/Helper'
    import TypeColor from '../../../assets/TypeColor'
    import StatisticTable from '../../../components/StatisticTable.vue'
    import ConversionsTabs from './ConversionsTabs.vue'
    // import { Carousel, Slide } from 'vue-carousel'

export default {
      name: 'Period',
      components: {
        Filters,
        StatisticTable,
        ConversionsTabs
          // Carousel,
          // Slide
      },
      data () {
        return {
          filtersScope: {
            dateFilter: true,
            offerFilter: true,
            courierFilter: true,
            filterWebCountry: true,
            countryFilter: true
          },
          Storage: Storage,
          TypeColor: TypeColor,
          Helper: Helper,
          country: null,
          he: null,
          loading: false,
          headColumns: [
              {label: this.$root.$t('statistic.offer'), field: 'offer', width: '100px'},
              {label: this.$root.$t('statistic.total'), field: 'total', colspan: 2, width: '150px'},
              {label: this.$root.$t('statistic.delivered'), field: 'delivered', width: '50px'},
              {label: this.$root.$t('statistic.averageBuyback'), field: 'averageBuyback', width: '150px'},
              {label: this.$root.$t('statistic.return'), field: 'return', colspan: 2, width: '60px'},
              {label: this.$root.$t('statistic.shippeds'), field: 'shipped', width: '35px'},
              {label: this.$root.$t('statistic.buyout'), field: 'buyout', width: '35px'},
              {label: 'Изм.', field: 'shift', width: '35px'}
          ],
          month: [
            'Январь',
            'Февраль',
            'Март',
            'Апрель',
            'Май',
            'Июнь',
            'Июль',
            'Август',
            'Сентябрь',
            'Октябрь',
            'Ноябрь',
            'Декабрь'
          ],
          rows: [],
          rowsTotal: [],
          footColumns: {},
          summary: {},
          totalAllColumns: {},
          offers: [],
          totalCourier: {},
          x: 0,
          dataForExel: ''
        }
      },
      mounted () {
        this.calculateRows()
        setTimeout(this.filterSectionHeight, 1500)
        this.$root.$on('filters_load_new_data', () => {
          this.calculateRows()
          this.he = null
          setTimeout(this.filterSectionHeight, 1500)
        })
      },
      methods: {
        filterSectionHeight () {
          this.he = null
          const filterSectionDOM = document.querySelectorAll('.heightInner')
          let maxArr = []
          for (var i = 0; i < filterSectionDOM.length; i++) {
            var boxes = filterSectionDOM[i].clientHeight
            maxArr.push(boxes)
          }
          this.he = max(maxArr)
          return this.he
        },
        onSwipe (e) {
          const offset = document.getElementById('swipe').offsetWidth
          const scroll = document.getElementById('swipe').scrollWidth
          const offset1 = document.getElementById('swipe1').offsetWidth
          const scroll1 = document.getElementById('swipe1').scrollWidth
          const width = scroll - offset
          const width1 = scroll1 - offset1
          if (width > 0) {
            if (e.deltaX >= 0) {
              this.x += e.distance / 10
            } else {
              this.x -= e.distance / 10
            }
            if (this.x > 0) {
              this.x = 0
            }
            if (Math.abs(this.x) > width) {
              this.x = -width
            }

            if (width1 > 0) {
              if (e.deltaX >= 0) {
                this.x += e.distance / 10
              } else {
                this.x -= e.distance / 10
              }
              if (this.x > 0) {
                this.x = 0
              }
              if (Math.abs(this.x) > width1) {
                this.x = -width1
              }
            }
          }
        },
        calculateRows () {
          this.rows = []
          this.footColumns = {}
          this.loading = true
          API.getConversionsCouriersStatistic().then(response => {
            this.rows = this.statisticData(response.body)
            this.loading = false
          }).catch(response => {
            this.loading = false
            this.$notify({
              type: 'danger',
              title: this.$root.$t('verbs.error'),
              text: !response.body.message ? response.body : response.body.message,
              animationType: 'velocity'
            })
          })
        },
        isNumeric (x) {
          return ((typeof x === 'number' || typeof x === 'string') && !isNaN(Number(x)))
        },
        statisticData (rows) {
          let newRows = {}
          let totalDeliveredCount1 = {}
          let years = []
          this.footColumns = {}
          this.totalAllColumns = {}
          let totalSum, deliveredSum, returnSum, shippedSum, sumPaid, sumAverageBuyback
          let allColumnsTotal, allColumnsPaid, allColumnsDelivered, allColumnsReturn, allColumnsShipped, allColumnsAverageBuyback
          let arrayMonth = []
          map(rows, (rowsMonth, indexYear) => {
            if (!newRows[indexYear]) {
              newRows[indexYear] = {}
              this.footColumns[indexYear] = {}
              this.totalAllColumns[indexYear] = {}
            }
            years.push(indexYear)
            totalDeliveredCount1 = { [indexYear]: {}, rowsMonth, years }
            map(rowsMonth, (rowsCourier, indexMonth) => {
              this.totalDeliveredCount = {}
              arrayMonth.push(indexMonth)
              totalDeliveredCount1[indexYear] = {
                [indexMonth]: {},
                ...totalDeliveredCount1[indexYear]
              }
              this.dataForExel = `${indexYear}-${indexMonth}`
              for (let courierIndex in rowsCourier) {
                Object.keys(rowsCourier[courierIndex]).map(courierKey => {
                  let courier = find(Storage.couriers, {id: parseInt(courierKey)})
                  if (!courier) {
                    if (courierKey === 'unsent') {
                      totalDeliveredCount1[indexYear][indexMonth] = {
                        [courierKey]: {
                          courier_name: 'Неотправленные',
                          total: 0,
                          delivered: 0,
                          average_buyout: 0,
                          paid: 0,
                          refunded: 0,
                          shipped: 0
                        },
                        ...totalDeliveredCount1[indexYear][indexMonth]
                      }
                    } else if (courierKey === 'without') {
                      totalDeliveredCount1[indexYear][indexMonth] = {
                        [courierKey]: {
                          courier_name: 'Без курьерки',
                          total: 0,
                          delivered: 0,
                          average_buyout: 0,
                          paid: 0,
                          refunded: 0,
                          shipped: 0
                        },
                        ...totalDeliveredCount1[indexYear][indexMonth]
                      }
                    } else {
                      totalDeliveredCount1[indexYear][indexMonth] = {
                        [courierKey]: {
                          courier_name: 'Undefined',
                          total: 0,
                          delivered: 0,
                          average_buyout: 0,
                          paid: 0,
                          refunded: 0,
                          shipped: 0
                        },
                        ...totalDeliveredCount1[indexYear][indexMonth]
                      }
                    }
                  } else {
                    totalDeliveredCount1[indexYear][indexMonth] = {
                      [courier.id]: {
                        courier_name: courier.title,
                        total: 0,
                        delivered: 0,
                        average_buyout: 0,
                        average_paid: 0,
                        paid: 0,
                        refunded: 0,
                        shipped: 0
                      },
                      ...totalDeliveredCount1[indexYear][indexMonth]
                    }
                  }
                })
              }
              if (!this.totalAllColumns[indexYear][indexMonth]) {
                this.totalAllColumns[indexYear][indexMonth] = []
                allColumnsTotal = 0
                allColumnsPaid = 0
                allColumnsDelivered = 0
                allColumnsAverageBuyback = 0.0
                allColumnsReturn = 0
                allColumnsShipped = 0
              }
              map(rowsCourier, (rowsData, indexCourier) => {
                if (!newRows[indexYear][indexCourier]) {
                  newRows[indexYear][indexCourier] = {}
                  this.footColumns[indexYear][indexCourier] = {}
                }
                if (!newRows[indexYear][indexCourier][indexMonth]) {
                  newRows[indexYear][indexCourier][indexMonth] = []
                  this.footColumns[indexYear][indexCourier][indexMonth] = []
                }
                map(arrayMonth, perMonth => {
                  if (!newRows[indexYear][indexCourier][perMonth]) {
                    newRows[indexYear][indexCourier][perMonth] = []
                    this.footColumns[indexYear][indexCourier][perMonth] = []
                  }
                })
                totalSum = 0
                deliveredSum = 0
                sumAverageBuyback = 0.0
                returnSum = 0
                shippedSum = 0
                sumPaid = 0
                map(rowsData, (rowsOfferTotal, i) => {
                  rowsOfferTotal.forEach(item => {
                    totalSum += parseInt(item.total)
                    deliveredSum += parseInt(item.delivered)
                    if (item.refunded) {
                      returnSum += parseInt(item.refunded)
                    }
                    shippedSum += parseInt(item.shipped)
                    if (item.percent_rate > 0) {
                    }
                    if (item.paid > 0) {
                      sumPaid += parseInt(item.paid)
                    }
                    if (item.average_buyout_usd > 0) {
                      sumAverageBuyback += parseFloat(item.average_buyout_usd) * item.paid
                    }
                  })
                })
                allColumnsPaid += parseInt(sumPaid)
                allColumnsTotal += parseInt(totalSum)
                allColumnsDelivered += parseInt(deliveredSum)
                allColumnsAverageBuyback += parseFloat(sumAverageBuyback)
                allColumnsReturn += parseInt(returnSum)
                allColumnsShipped += parseInt(shippedSum)
                map(rowsData, (rowsOffer, i) => {
                  rowsOffer.forEach(item => {
                    newRows[indexYear][indexCourier][indexMonth].push({
                      offer: {
                        value: `${this.isNumeric(i) ? Helper.getCourierTitleWithUndefinedCourier(Storage.couriers, i) : this.$root.$t(`verbs.${i}`)}`
                      },
                      total: {
                        value: item.total,
                        bg: true
                      },
                      totalPercent: {
                        value: Helper.percents(totalSum, item.total),
                        bgg: Helper.renderGistPart(totalSum, item.total, true)
                      },
                      delivered: {
                        value: item.delivered,
                        bg: true
                      },
                      averageBuyback: {
                        value: '$ ' + item.average_buyout_usd.toFixed(2),
                        bg: true
                      },
                      return: {
                        value: item.refunded,
                        bg: true
                      },
                      returnPercents: {
                        value: Helper.percents(parseFloat(item.approved), item.refunded),
                        bgg: Helper.renderGistPart(item.approved, item.refunded, true)
                      },
                      shipped: {
                        value: item.shipped,
                        bg: true
                      },
                      buyout: {
                        value: `${item.percent_rate}%`,
                        bg: true
                      },
                      shift: {
                        value: `${(item.percent_rate - item.old_buyout_percent).toFixed(2)}%`,
                        bg: true
                      }
                    })
                  })
                })
                this.footColumns[indexYear][indexCourier][indexMonth].push({
                  label: {
                    value: this.$root.$t('statistic.in_total')
                  },
                  total: {
                    value: totalSum
                  },
                  totalPercent: {
                    value: ``
                  },
                  delivered: {
                    value: deliveredSum
                  },
                  averageBuyback: {
                    value: Helper.averageBillDayCount(sumAverageBuyback, sumPaid)
                    // value: sumPaid > 0 ? '$ ' + (sumAverageBuyback / sumPaid).toFixed(2) : '$ 0.00'
                  },
                  return: {
                    value: returnSum
                  },
                  returnPercents: {
                    value: `${parseFloat((returnSum / totalSum) * 100).toFixed(0)}%`
                  },
                  shipped: {
                    value: shippedSum
                  },
                  buyout: {
                    value: `${Helper.percents(totalSum, deliveredSum)}`,
                    bg: true
                  },
                  shift: {
                    value: ``
                  }
                })
              })
              this.totalAllColumns[indexYear][indexMonth].push({
                label: {
                  value: this.$root.$t('statistic.in_total'),
                  width: '14%'
                },
                total: {
                  value: allColumnsTotal,
                  width: '10%'
                },
                totalPercent: {
                  value: ``,
                  width: '13%'
                },
                delivered: {
                  value: allColumnsDelivered,
                  width: '15%'
                },
                averageBuyback: {
                  value: Helper.averageBillDayCount(allColumnsAverageBuyback, allColumnsPaid),
                  width: '15%'
                },
                return: {
                  value: allColumnsReturn,
                  width: '5%'
                },
                returnPercents: {
                  value: `${parseFloat((allColumnsReturn / allColumnsTotal) * 100).toFixed(0)}%`,
                  width: '9%'
                },
                shipped: {
                  value: allColumnsShipped,
                  width: '12%'
                },
                buyout: {
                  value: `${Helper.percents(allColumnsTotal, allColumnsDelivered)}`,
                  bg: true,
                  width: '10%'
                },
                shift: {
                  value: ``,
                  width: '11%'
                }
              })
            })
          })
          totalDeliveredCount1.years.map(year => {
            for (let key in totalDeliveredCount1.rowsMonth) {
              let month = key
              let company = totalDeliveredCount1.rowsMonth[key]
              for (let key in company) {
                Object.keys(company[key]).map(courierId => {
                  company[key][courierId].forEach(item => {
                    totalDeliveredCount1[year][month][courierId].total += parseInt(item.total)
                    totalDeliveredCount1[year][month][courierId].delivered += parseInt(item.delivered)
                    totalDeliveredCount1[year][month][courierId].paid += parseInt(item.paid)
                    totalDeliveredCount1[year][month][courierId].average_buyout += parseFloat(item.average_buyout_usd.toFixed(2)) * parseInt(item.paid)
                    totalDeliveredCount1[year][month][courierId].refunded += parseInt(item.refunded)
                    totalDeliveredCount1[year][month][courierId].shipped += parseInt(item.shipped)
                    totalDeliveredCount1[year][month][courierId].returnPercents = `${parseFloat((totalDeliveredCount1[year][month][courierId].refunded / totalDeliveredCount1[year][month][courierId].total) * 100).toFixed(0)}%`
                    totalDeliveredCount1[year][month][courierId].buyout = `${Helper.percents(totalDeliveredCount1[year][month][courierId].total, totalDeliveredCount1[year][month][courierId].delivered)}`
                    totalDeliveredCount1[year][month][courierId].totalPercents = this.totalAllColumns[year][month][0].total.value
                  })
                })
              }
            }
          })

          this.totalCourier = totalDeliveredCount1
          return newRows
        },
        exportingAll () {
          const classes = document.getElementsByClassName('exelAll')
          let doc = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>${this.title}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>`
          map(classes, (cl, i) => {
            doc += `${cl.innerHTML}<br/>`
          })
          doc += '</body></html>'
          FileSaver.saveAs(new Blob([doc], {
            encoding: 'UTF-8',
            type: 'application/octet-stream'
          }), `analytics-${this.dataForExel}.xls`)
        }
      }
}
</script>

<style>
    .courier .newRow{
        display: flex;
        flex-wrap: nowrap;
        margin-right: -15px;
        margin-left: -15px;
    }
    .courier .tr_flypost {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// Courier.vue?1420c0e4